import React, { useState, useEffect, useRef } from 'react';

import { FormattedMessage } from 'react-intl';
import debounce from 'lodash.debounce';

import { Button } from '@xingternal/button';
import { IconArrowDown, IconArrowUp } from '@xingternal/icons';

import styles from './ReadMore.css';

type ReadMoreProps = {
  children: React.ReactNode;
  maxHeight: number;
  trackingAction?: () => void;
};
const ReadMore = ({ children, maxHeight, trackingAction }: ReadMoreProps) => {
  const ref = useRef<any>(null);
  const [isCollapsed, setCollapsed] = useState<boolean>(true);
  const [totalHeight, setTotalHeight] = useState<any>();

  const updateHeight = () => {
    setTotalHeight(ref.current.getBoundingClientRect()?.height);
  };

  const updateHeightDebounced = debounce(() => updateHeight(), 300);

  useEffect(() => {
    if (ref.current.getBoundingClientRect().height !== 0) {
      updateHeight();
    }
  }, [children]);

  useEffect(() => {
    window.addEventListener('resize', updateHeightDebounced);

    return () => {
      window.removeEventListener('resize', updateHeightDebounced);
    };
  }, []);

  return (
    <>
      <div
        className={styles.textArea}
        style={{ maxHeight: isCollapsed ? maxHeight : totalHeight }}
      >
        <div ref={ref} className={styles.textAreaInner}>
          {children}
        </div>
      </div>
      {totalHeight > maxHeight && (
        <Button
          variant={'tertiary'}
          size={'small'}
          icon={isCollapsed ? IconArrowDown : IconArrowUp}
          onClick={() => {
            isCollapsed && trackingAction && trackingAction();
            setCollapsed(!isCollapsed);
          }}
          className={styles.readMoreButton}
        >
          <FormattedMessage
            id={isCollapsed ? 'EP_READ_MORE' : 'EP_READ_LESS'}
          />
        </Button>
      )}
    </>
  );
};

export default ReadMore;
